/**
 * Cookie Helper Functions for Authentication
 *
 * Utilities for managing authentication cookies across domains and localhost
 */

/**
 * Get domain attribute for cookie based on hostname
 * Handles localhost (cross-port) and production domains
 */
const getDomainAttribute = () => {
  const hostname = window.location.hostname;

  if (hostname === "localhost") {
    return "Domain=localhost; ";
  }

  if (hostname.includes(".")) {
    const parts = hostname.split(".");
    if (parts.length >= 2) {
      const rootDomain = `.${parts.slice(-2).join(".")}`;
      return `Domain=${rootDomain}; `;
    }
  }

  return "";
};

/**
 * Set access token cookie
 */
export const setAccessTokenCookie = (value) => {
  try {
    const isSecure = window?.location?.protocol === "https:";
    const maxAge = 60 * 60 * 24 * 90; // 90 days
    const domainAttr = getDomainAttribute();

    document.cookie = `access_token=${value}; ${domainAttr}Path=/; SameSite=Lax; Max-Age=${maxAge}${isSecure ? "; Secure" : ""}`;
  } catch (e) {
    console.warn("Unable to set access_token cookie:", e);
  }
};

/**
 * Set user data cookie
 */
export const setUserDataCookie = (userData) => {
  try {
    const isSecure = window?.location?.protocol === "https:";
    const maxAge = 60 * 60 * 24 * 90; // 90 days
    const encoded = encodeURIComponent(JSON.stringify(userData || {}));
    const domainAttr = getDomainAttribute();

    document.cookie = `user_data=${encoded}; ${domainAttr}Path=/; SameSite=Lax; Max-Age=${maxAge}${isSecure ? "; Secure" : ""}`;
  } catch (e) {
    console.warn("Unable to set user_data cookie:", e);
  }
};

/**
 * Clear access token cookie
 */
export const clearAccessTokenCookie = () => {
  try {
    const domainAttr = getDomainAttribute();
    // Clear with domain attribute
    document.cookie = `access_token=; ${domainAttr}Path=/; Max-Age=0; SameSite=Lax`;
    // Also clear without domain attribute (for backwards compatibility)
    document.cookie = "access_token=; Path=/; Max-Age=0; SameSite=Lax";
  } catch (e) {
    console.warn("Unable to clear access_token cookie:", e);
  }
};

/**
 * Clear user data cookie
 */
export const clearUserDataCookie = () => {
  try {
    const domainAttr = getDomainAttribute();
    // Clear with domain attribute
    document.cookie = `user_data=; ${domainAttr}Path=/; Max-Age=0; SameSite=Lax`;
    // Also clear without domain attribute (for backwards compatibility)
    document.cookie = "user_data=; Path=/; Max-Age=0; SameSite=Lax";
  } catch (e) {
    console.warn("Unable to clear user_data cookie:", e);
  }
};
